var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import api from '@utils/api-client';
import { apiInternalDeficiencyResolutionStatusesPath } from '@routes';
export function fetchResolutionStatuses() {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const response = yield api.get(apiInternalDeficiencyResolutionStatusesPath());
            return response.data.deficiencyResolutionStatuses.map((status) => ({
                id: status.value,
                name: status.label
            }));
        }
        catch (error) {
            console.error('Error getting statuses:', error);
            throw error;
        }
    });
}
export function addResolutionStatus(request) {
    return __awaiter(this, void 0, void 0, function* () {
        const { data } = yield api.post(apiInternalDeficiencyResolutionStatusesPath(), {
            // eslint-disable-next-line @typescript-eslint/naming-convention
            type_name: request.name
        });
        return data;
    });
}
